// Environment detection utility - use process.env for build-time constants
function isProd(): boolean {
  const env = String(
    process.env.NUXT_PUBLIC_APP_ENV || process.env.APP_ENV || '',
  ).toLowerCase()
  return env === 'production'
}

export const NAVIGATION_IDS = {
  HOME: {
    BRANDS: 40371,
    CLIQUE: 40470,
    TRENDS: 40471,
  },
  MEN: {
    BRANDS: 40600,
    ALL: 40480,
    CLIQUE: 40696,
    TRENDS: 40697,
  },
  WOMEN: {
    ALL: 40706,
    BRANDS: 40829,
    CLIQUE: 40925,
    TRENDS: 40926,
  },
  KIDS: {
    BRANDS: 41060,
    ALL: 40935,
    CLIQUE: 41155,
    TRENDS: 41156,
  },
} as const

// Array of all ignored navigation IDs for filtering
export const IGNORED_NAVIGATION_IDS = Object.values(NAVIGATION_IDS).flatMap(
  (category) => Object.values(category),
)

export const MENU_NAVIGATION_NAME = 'Navigation'

// Navigation IDs - different values for production vs other environments
export const NAVIGATION_IDS_DEV = {
  'Navigation EU Men': 44,
  'Navigation EU Kids': 46,
  'Navigation EU Women': 45,
  'Navigation EU': 44,
  'Navigation EU - Footer': 49,

  // Pl Navigation
  'Navigation PL': 51,
  'Navigation PL Kobiety': 53,
  'Navigation PL Mezczyzni': 52,
  'Navigation PL Dzieci': 54,
  'Navigation PL - Footer': 55,
} as const

export const NAVIGATION_IDS_PROD = {
  'Navigation EU Men': 44,
  'Navigation EU Kids': 46,
  'Navigation EU Women': 45,
  'Navigation EU': 42,
  'Navigation EU - Footer': 48,

  // Pl Navigation
  'Navigation PL': 51,
  'Navigation PL Kobiety': 53,
  'Navigation PL Mezczyzni': 52,
  'Navigation PL Dzieci': 54,
  'Navigation PL - Footer': 55,
} as const

export const NAVIGATION_ID_MAP: Record<string, number> = isProd()
  ? NAVIGATION_IDS_PROD
  : NAVIGATION_IDS_DEV
